import { render, staticRenderFns } from "./newBackupSystem.vue?vue&type=template&id=906aecac&scoped=true"
import script from "./newBackupSystem.vue?vue&type=script&lang=js"
export * from "./newBackupSystem.vue?vue&type=script&lang=js"
import style0 from "./newBackupSystem.vue?vue&type=style&index=0&id=906aecac&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "906aecac",
  null
  
)

export default component.exports